
import { IWorkflowService } from './workflow.types'
import { http } from '@/shared/https'

export class WorkflowService implements IWorkflowService {
    
    /** validate the workflow actions */
    validate(transactionId: number, workflowStepId: number, entity: string): any {
        return http.post(`api/Workflow/Validate/${transactionId}/Workflow/${workflowStepId}`, entity)
        .then((resp: any) => {
            if (resp.status >= 200 && resp.status < 300) {
                return resp.data;
            } else {
                throw (resp.data);
            }
        })
    }
}